export default __webpack_public_path__ + "static/media/cwu16.66182113.jpeg";